module.exports = __webpack_public_path__ + "static/apple-icon-72x72-1112a8b78c8eae40905254e0129b000e.png";